import Close from '@mui/icons-material/Close';
import { dialogContentClasses } from '@mui/material';
import DialogTitle, { dialogTitleClasses } from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { SxProps, Theme } from '@mui/material/styles';
import { t } from 'i18next';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';

type DialogHeaderProps = {
  onClose?: () => void;
  sx?: SxProps<Theme>;
};

export default function DialogHeader({
  children,
  onClose,
  sx,
}: React.PropsWithChildren<DialogHeaderProps>) {
  const isString = typeof children === 'string';

  return (
    <DialogTitle
      component="div"
      sx={[
        (theme) => ({
          alignItems: 'center',
          borderBottom: `solid 1px ${theme.brandV2.colors.treadGray7}`,
          display: 'flex',
          gap: 2,
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          [`&.${dialogTitleClasses.root} + .${dialogContentClasses.root}`]: { pt: 0 },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {isString ? (
        <OverflowAwareText sx={{ flex: 1, fontSize: '16px', fontWeight: 600 }}>
          {children}
        </OverflowAwareText>
      ) : (
        children
      )}

      {onClose && (
        <IconButton
          aria-label={t('actions.close')}
          onClick={onClose}
          size="small"
          sx={(theme) => ({
            height: '24px',
            width: '24px',
            [`&:hover`]: { color: theme.brandV2.colors.treadBlack },
          })}
        >
          <Close sx={{ fontSize: '16px' }} />
        </IconButton>
      )}
    </DialogTitle>
  );
}
